import * as z from "zod";
import {SimpleResModel} from "./SimpleResModel";

const schema = z.object({
	content: z.array(SimpleResModel.model).default([]),
	currentPage: z.number().default(0),
	pageSize: z.number().default(20),
	totalCount: z.number().default(0),
	totalPages: z.number().default(0)
});

const model = schema.transform((values) => ({
	...values
}));

export const TaxAccountantSimpleResModel = {schema, model};
export type ITaxAccountantSimpleResModel = z.infer<typeof TaxAccountantSimpleResModel.model>;
export const DEFAULT_TAX_ACCOUNTANT_SIMPLE_RES: ITaxAccountantSimpleResModel = {
	content: [],
	currentPage: 0,
	pageSize: 20,
	totalCount: 0,
	totalPages: 0
};
